import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './global.css';
import './fonts/Overpass/Overpass-VariableFont_wght.ttf';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import { StyledEngineProvider } from '@mui/material/styles';
import { Auth0Provider } from '@auth0/auth0-react';

const container = document.getElementById('root');
if (container === null) throw new Error('Root container missing in index.html');

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          {process.env.REACT_APP_AUTH0_ENABLED_FEATURE_FLAG === 'true' ? (
            <Auth0Provider
              domain={
                process.env.REACT_APP_AUTH0_DOMAIN ||
                'BUGGER:REACT_APP_AUTH0_DOMAIN'
              }
              clientId={
                process.env.REACT_APP_AUTH0_CLIENT_ID ||
                'BUGGER:REACT_APP_AUTH0_CLIENT_ID'
              }
              redirectUri={process.env.REACT_APP_AUTH_REDIRECT_SIGNIN}
              prompte='none' // this triggers silent logins if a page refresh occurs
              audience={process.env.REACT_APP_AUTH0_AUDIENCE}
            >
              <App />
            </Auth0Provider>
          ) : (
            <App />
          )}
        </StyledEngineProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
